import { Props_SnippetLinkBox } from './LinkBox.props'
import SnippetLink from '../Shared/Link/Link'

const SnippetLinkBox = (props: Props_SnippetLinkBox) => {
    const { heading, repeatable_entry } = props
    const classHeadingVisibiity: string = heading.visibility?.value ? '' : 'snippet-link-box__heading--hidden'

    return (
    <section className="snippet-link-box">
        <div className={`snippet-link-box__container`}>
            <h2 className={`snippet-link-box__heading ${classHeadingVisibiity}`}>{ heading.content.value }</h2>
            <div className="snippet-link-box__container-entries">
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className={`snippet-link-box__entry`}>
                    <figure className="snippet-link-box__entry-container-image">
                        <img
                            className="snippet-link-box__entry-image"
                            loading="lazy"
                            height="300"
                            width="300"
                            src={entry.image?.value}
                            alt={entry?.alt?.value ? entry.alt.value : ''}
                        />
                    </figure>
                    <div className="snippet-link-box__entry-container-content">
                        <h3 className="snippet-link-box__entry-title">{ entry.heading?.value }</h3>
                       
                            <SnippetLink
                                linkStyles={entry.linkStyle?.value}     
                                className="snippet-link-box__entry-link"
                                url={entry.linkHref?.value}
                                openInNewTab={entry.linkTarget?.value}
                            >
                                {entry.linkText?.value}
                            </SnippetLink>
                        
                    </div>
                </div>
            ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetLinkBox